import { router } from 'expo-router'

import { Listbox } from '@/src/elements/listbox'
import { Stack } from '@/src/elements/navigation/Stack'
import { Placeholder, PlaceholderLine, PlaceholderMedia } from '@/src/elements/placeholder'
import { SaintListItem } from '@/src/elements/saint-list-item/SaintListItem'
import { useMeQuery } from '@/src/features/auth/services/useMeQuery'
import { USER_TITLE } from '@/src/features/user/models/user.enum'
import { TEST_ID } from '@/src/general/constants/testId'
import { getAvatarUrl } from '@/src/general/utils/getAvatarUrl'
import { useRoutes } from '@/src/general/utils/routes'
import { useTranslate } from '@/src/lang/useTranslate'

import { useAvatarQuery } from '../../services/useAvatarsQuery'
import { SettingsScreenWrapper } from '../components/SettingsScreenWrapper'

export const SettingsAvatarScreen = () => {
  const { data, isPending } = useAvatarQuery()
  const { data: me } = useMeQuery()
  const { routes } = useRoutes()
  const { t } = useTranslate()

  return (
    <SettingsScreenWrapper testID={TEST_ID.SETTINGS.AVATAR_LIST_SCREEN}>
      <Stack.Screen options={{ title: t('user.popins.avatars.choose-my-image') }} />
      <Listbox>
        {(me?.title === USER_TITLE.ORG || me?.avatar?.isCustom) && (
          <SaintListItem
            key="logo"
            testId="custom-avatar"
            isSelected={me.avatar?.isCustom}
            iconUrl={getAvatarUrl(me.avatar)}
            name={t('user.avatar.logo')}
            onPress={() => router.navigate(routes.uploadAvatar())}
          />
        )}
        {isPending &&
          Array.from({ length: 5 }, (_, index) => (
            <Placeholder className="ml-0 mt-2 items-center gap-4 bg-white px-3" key={index}>
              <PlaceholderMedia />
              <PlaceholderLine size="md" className="max-w-40" />
            </Placeholder>
          ))}
        {!isPending &&
          data &&
          [...data]
            .sort((a, b) => {
              if (me?.avatar?.id === a.id) return -1
              if (me?.avatar?.id === b.id) return 1
              return 0
            })
            ?.map((item) => (
              <SaintListItem
                key={item.id}
                testId={`avatar-${item.id}`}
                isSelected={me?.avatar?.id === item.id}
                iconUrl={getAvatarUrl(item)}
                name={item.name}
                onPress={() => router.navigate(routes.settingsAvatar(item.id))}
              />
            ))}
      </Listbox>
    </SettingsScreenWrapper>
  )
}
